import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  h1 {
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.3rem;
  }
  span {
    font-size: 1rem;
    font-weight: 400;
  }
  .header {
    display: flex;
    justify-content: flex-end;
    button {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      border: none;
      background: none;
      cursor: pointer;
      font-size: 1.2rem;
      color: ${({ theme }) => theme.colors.tertiary_500};
      text-decoration: underline;
      svg {
        width: 1rem;
        height: 1rem;
        fill: ${({ theme }) => theme.colors.tertiary_500};
      }
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .justificationText {
      display: flex;
      max-height: 6rem;
      width: 90%;
      padding: 0.5rem;
      border-radius: 1rem;
      font-size: 1rem;
      overflow-y: auto;
      color: ${({ theme }) => theme.colors.text_gray};
    }
    .MuiInputBase-root {
      border-radius: 0.8rem;
      width: 70%;
      margin: 0.5rem 0;
      padding: 0;
    }
    .fieldError {
      padding: 0;
      color: red;
      display: flex;
      align-items: center;
      font-size: 1rem;
      flex-wrap: nowrap;
      svg {
        margin-right: 2px;
        font-size: 1rem;
        padding-bottom: 0.1rem;
      }
    }
    .justification {
      display: flex;
      min-height: 6rem;
      max-height: 6rem;
      width: 90%;
      padding: 0.5rem;
      border-radius: 1rem;
      font-size: 1rem;
      overflow-y: auto;
      resize: none;
      margin: 0.5rem 0;
      border-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.text_gray};
    }
    .containerButton {
      display: flex;
      justify-content: center;
    }
  }
`;
